import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Base API URL for bookmarks
const API_URL = '/api/bookmarks';

export const fetchBookmarks = createAsyncThunk(
    'bookmarks/fetchBookmarks',
    async (_, { rejectWithValue }) => {
      try {
        const response = await fetch(API_URL, {
          method: 'GET',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
          },
        });
  
        if (response.status === 401) {
          return rejectWithValue('User not logged in');
        }
  
        if (!response.ok) {
          throw new Error('Failed to fetch bookmarks');
        }
  
        return await response.json();
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );
  
  
  export const addBookmark = createAsyncThunk(
    'bookmarks/addBookmark',
    async (bookmarkData, { rejectWithValue }) => {
      try {
        const response = await fetch(API_URL, {
          method: 'POST',
          credentials: 'include', // Include cookies for session authentication
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(bookmarkData), // Serialize the payload
        });
  
        if (!response.ok) {
          const errorData = await response.json(); // Parse server error details
          console.error('Server error:', errorData); // Log error for debugging
          throw new Error('Failed to add bookmark');
        }
  
        return await response.json(); // Return the created bookmark
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );
  
export const deleteBookmark = createAsyncThunk(
  'bookmarks/deleteBookmark',
  async (bookmarkId, { rejectWithValue }) => {
    try {
      const response = await fetch(`${API_URL}/${bookmarkId}`, {
        method: 'DELETE',
      });
      if (!response.ok) {
        throw new Error('Failed to delete bookmark');
      }
      return bookmarkId;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Slice definition
const bookmarkSlice = createSlice({
  name: 'bookmarks',
  initialState: {
    bookmarks: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBookmarks.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBookmarks.fulfilled, (state, action) => {
        state.loading = false;
        state.bookmarks = action.payload;
      })
      .addCase(fetchBookmarks.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(addBookmark.fulfilled, (state, action) => {
        state.bookmarks.push(action.payload);
      })
      .addCase(addBookmark.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(deleteBookmark.fulfilled, (state, action) => {
        state.bookmarks = state.bookmarks.filter((bm) => bm.id !== action.payload);
      })
      .addCase(deleteBookmark.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export default bookmarkSlice.reducer;
